module.exports = __webpack_public_path__ + "fonts/steelfish bd.38620a21.woff";